"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_CODE_TABLES = void 0;
exports.sessionEntryByCode = sessionEntryByCode;
exports.hasSessionCode = hasSessionCode;
exports.sessionAgreementCode = sessionAgreementCode;
exports.sessionConfirmedCode = sessionConfirmedCode;
exports.sessionApplyBinaryCode = sessionApplyBinaryCode;
exports.sessionApplyBinaryFromStoredLenient = sessionApplyBinaryFromStoredLenient;
exports.sessionApplyBinaryFromStored = sessionApplyBinaryFromStored;
exports.sessionApplyBinaryDxoFromStored = sessionApplyBinaryDxoFromStored;
/** 申込なし/申込ありの共通定義（大和ネクスト銀行・外貨口座で共用） */
const APPLY = {
    notApplied: { code: "0", name: "申込なし", dxoCode: "0" },
    applied: { code: "1", name: "申込あり", dxoCode: "1" },
};
/** セッションコードテーブル。各エントリのキーはフォーム state key（都道府県はローマ字略称）。wire/API 用の値は `code`。 */
exports.SESSION_CODE_TABLES = {
    CONFIRMED: {
        notConfirmed: { code: "0", name: "" },
        confirmed: { code: "1", name: "確認済" },
    },
    AGREEMENT: {
        notAgreed: { code: "0", name: "" },
        agreed: { code: "1", name: "同意" },
    },
    PREFECTURE: {
        hokkaido: { code: "01", name: "北海道", kana: "ホッカイドウ" },
        aomori: { code: "02", name: "青森県", kana: "アオモリケン" },
        iwate: { code: "03", name: "岩手県", kana: "イワテケン" },
        miyagi: { code: "04", name: "宮城県", kana: "ミヤギケン" },
        akita: { code: "10", name: "秋田県", kana: "アキタケン" },
        yamagata: { code: "11", name: "山形県", kana: "ヤマガタケン" },
        fukushima: { code: "12", name: "福島県", kana: "フクシマケン" },
        ibaraki: { code: "20", name: "茨城県", kana: "イバラキケン" },
        tochigi: { code: "21", name: "栃木県", kana: "トチギケン" },
        gunma: { code: "22", name: "群馬県", kana: "グンマケン" },
        saitama: { code: "23", name: "埼玉県", kana: "サイタマケン" },
        chiba: { code: "24", name: "千葉県", kana: "チバケン" },
        tokyo: { code: "25", name: "東京都", kana: "トウキョウト" },
        kanagawa: { code: "26", name: "神奈川県", kana: "カナガワケン" },
        niigata: { code: "30", name: "新潟県", kana: "ニイガタケン" },
        toyama: { code: "31", name: "富山県", kana: "トヤマケン" },
        ishikawa: { code: "32", name: "石川県", kana: "イシカワケン" },
        fukui: { code: "33", name: "福井県", kana: "フクイケン" },
        yamanashi: { code: "34", name: "山梨県", kana: "ヤマナシケン" },
        nagano: { code: "40", name: "長野県", kana: "ナガノケン" },
        gifu: { code: "41", name: "岐阜県", kana: "ギフケン" },
        shizuoka: { code: "42", name: "静岡県", kana: "シズオカケン" },
        aichi: { code: "43", name: "愛知県", kana: "アイチケン" },
        mie: { code: "44", name: "三重県", kana: "ミエケン" },
        shiga: { code: "50", name: "滋賀県", kana: "シガケン" },
        kyoto: { code: "57", name: "京都府", kana: "キョウトフ" },
        osaka: { code: "58", name: "大阪府", kana: "オオサカフ" },
        hyogo: { code: "59", name: "兵庫県", kana: "ヒョウゴケン" },
        nara: { code: "60", name: "奈良県", kana: "ナラケン" },
        wakayama: { code: "61", name: "和歌山県", kana: "ワカヤマケン" },
        tottori: { code: "62", name: "鳥取県", kana: "トットリケン" },
        shimane: { code: "63", name: "島根県", kana: "シマネケン" },
        okayama: { code: "64", name: "岡山県", kana: "オカヤマケン" },
        hiroshima: { code: "70", name: "広島県", kana: "ヒロシマケン" },
        yamaguchi: { code: "71", name: "山口県", kana: "ヤマグチケン" },
        tokushima: { code: "72", name: "徳島県", kana: "トクシマケン" },
        kagawa: { code: "73", name: "香川県", kana: "カガワケン" },
        ehime: { code: "74", name: "愛媛県", kana: "エヒメケン" },
        kochi: { code: "80", name: "高知県", kana: "コウチケン" },
        fukuoka: { code: "81", name: "福岡県", kana: "フクオカケン" },
        saga: { code: "82", name: "佐賀県", kana: "サガケン" },
        nagasaki: { code: "83", name: "長崎県", kana: "ナガサキケン" },
        kumamoto: { code: "84", name: "熊本県", kana: "クマモトケン" },
        oita: { code: "90", name: "大分県", kana: "オオイタケン" },
        miyazaki: { code: "91", name: "宮崎県", kana: "ミヤザキケン" },
        kagoshima: { code: "92", name: "鹿児島県", kana: "カゴシマケン" },
        okinawa: { code: "93", name: "沖縄県", kana: "オキナワケン" },
        overseas: { code: "99", name: "海外", kana: "カイガイ" },
    },
    HOUSEHOLD_HEAD_CONFIRMATION: {
        notHeadOfHousehold: { code: "0", name: "世帯主でない", dxoCode: null }, // DXOコードはRELATIONの値を設定
        headOfHousehold: { code: "1", name: "世帯主である", dxoCode: "1" },
    },
    ACCOUNT_TYPE: {
        bankOrOtherFinancial: { code: "1", name: "銀行口座・その他金融機関", dxoCode: "0" },
        yuchoBank: { code: "2", name: "ゆうちょ銀行", dxoCode: "1" },
    },
    BANK_INFO_TYPE: {
        ordinary: { code: "1", name: "普通", dxoCode: "1" },
        current: { code: "2", name: "当座", dxoCode: "2" },
        savingsDeposit: { code: "4", name: "貯蓄預金", dxoCode: "4" },
    },
    RELATION: {
        self: { code: "1", name: "本人", dxoCode: "1" },
        spouse: { code: "2", name: "配偶者", dxoCode: "2" },
        child: { code: "3", name: "子供", dxoCode: "3" },
        grandchild: { code: "4", name: "孫", dxoCode: "4" },
        other: { code: "9", name: "その他", dxoCode: "9" },
    },
    /** キーは CustomerCardInputType firstSection.investExperience.values の state key */
    INVESTMENT_EXPERIENCE: {
        noInvestmentExperience: { code: "0", name: "投資経験なし" },
        domesticStocks: { code: "1", name: "国内株式" },
        foreignStocks: { code: "2", name: "外国株式" },
        stockInvestmentTrust: { code: "3", name: "株式投資信託" },
        domesticBonds: { code: "4", name: "国内債券" },
        foreignBonds: { code: "5", name: "外国債券" },
        bondInvestmentTrust: { code: "6", name: "公社債投資信託" },
        foreignCurrency: { code: "7", name: "外貨預金" },
        pensionInsurance: { code: "8", name: "年金保険" },
        moneyTrust: { code: "9", name: "金銭・貸付信託" },
        internetTrading: { code: "10", name: "インターネット取引" },
        creditDerivatives: { code: "11", name: "信用・デリバティブ" },
        shareholderAssociation: { code: "12", name: "持株会" },
    },
    /** キーは CustomerCardInputType secondSection.tradingExperience.values の state key */
    INITIAL_PLANNED_TRANSACTION_TYPE: {
        domesticStocks: { code: "1", name: "国内株式" },
        foreignStocks: { code: "2", name: "外国株式" },
        domesticBonds: { code: "3", name: "国内債券" },
        foreignBonds: { code: "4", name: "外国債券" },
        stockInvestmentTrust: { code: "5", name: "株式投資信託" },
        bondInvestmentTrust: { code: "6", name: "公社債投資信託" },
        pensionInsurance: { code: "7", name: "年金保険" },
        creditDerivatives: { code: "8", name: "信用・デリバティブ" },
    },
    TRANSACTION_MOTIVATION: {
        referral: { code: "1", name: "ご紹介を受け" },
        salesStaffVisit: { code: "2", name: "当社営業員の訪問により" },
        salesStaffPhone: { code: "3", name: "当社営業員の電話により" },
        seminar: { code: "4", name: "講演会等・セミナーに参加して" },
        branchChange: { code: "6", name: "お取扱店変更のため" },
        directMail: { code: "8", name: "ダイレクトメールにより" },
        other: { code: "11", name: "その他" },
        mediaAd: { code: "12", name: "新聞・TV等の広告を見て" },
        savingsOrShareholding: { code: "13", name: "財形貯蓄・持株会に加入していたので" },
        companyWebsite: { code: "14", name: "当社ホームページを見て" },
    },
    INVESTMENT_PURPOSE_INFO_POLICY: {
        stableIncome: { code: "1", name: "利子・配当等安定収益重視", dxoCode: "1" },
        capitalGains: { code: "2", name: "値上がり益重視", dxoCode: "2" },
        balanced: { code: "3", name: "利子・配当等安定収益と値上がり益のバランス投資", dxoCode: "3" },
    },
    INVESTMENT_PURPOSE_INFO_PERIOD: {
        longTerm: { code: "1", name: "長期運用", dxoCode: "1" },
        mediumTerm: { code: "2", name: "中期運用", dxoCode: "2" },
        shortTerm: { code: "3", name: "短期運用", dxoCode: "3" },
        unspecified: { code: "4", name: "特に定めない", dxoCode: "4" },
    },
    /** キーは CustomerCardInputType fifthSection.fundSource.values の state key（otherText を除く） */
    PLANNED_FUND_SOURCE: {
        salary: { code: "1", name: "給与（退職金含む）" },
        savings: { code: "2", name: "貯蓄" },
        pension: { code: "3", name: "年金" },
        inheritance: { code: "4", name: "相続・贈与" },
        businessIncome: { code: "5", name: "事業収入" },
        rentalIncome: { code: "6", name: "賃貸料（不動産等）" },
        investmentIncome: { code: "7", name: "資産運用益（配当・利金含む）" },
        assetSale: { code: "8", name: "資産売却資金" },
        foreignIncome: { code: "9", name: "海外関連資金" },
        other: { code: "10", name: "その他" },
    },
    INVESTOR_FINANCIAL_RANGE: {
        under5M: { code: "1", name: "5百万円未満", dxoCode: "1" },
        from5MTo10M: { code: "2", name: "5百万円〜1千万円未満", dxoCode: "2" },
        from10MTo30M: { code: "3", name: "1千万円〜3千万円未満", dxoCode: "3" },
        from30MTo50M: { code: "4", name: "3千万円〜5千万円未満", dxoCode: "4" },
        from50MTo100M: { code: "5", name: "5千万円〜1億円未満", dxoCode: "5" },
        over100M: { code: "6", name: "1億円以上", dxoCode: "6" },
    },
    ONLINE_TRADE_E_MEMBER: {
        notApplied: { code: "0", name: "申込なし", dxoCode: "0" },
        applied: { code: "1", name: "申込あり", dxoCode: "1" },
    },
    DAIWA_CARD: {
        notApplied: { code: "0", name: "申込なし", dxoCode: "0" },
        applied: { code: "1", name: "申込あり", dxoCode: "2" },
    },
    SPECIFIC_ACCOUNT: {
        notApplied: { code: "0", name: "申込なし", dxoCode: "2" },
        withWithholding: { code: "1", name: "申込あり(源泉徴収あり)", dxoCode: "0" },
        withoutWithholding: { code: "2", name: "申込あり(源泉徴収なし)", dxoCode: "1" },
    },
    NISA_ACCOUNT: {
        notApplied: { code: "0", name: "申込なし", dxoCode: "2" },
        applied: { code: "1", name: "申込あり", dxoCode: "3" },
    },
    DIVIDEND_PROPORTIONAL_METHOD: {
        notApplied: { code: "0", name: "申込なし", dxoCode: "0" },
        applied: { code: "1", name: "申込あり", dxoCode: "1" },
    },
    DAIWA_NEXT_BANK_ACCOUNT: APPLY,
    FOREIGN_CURRENCY_ACCOUNT: APPLY,
    /** キーは DaiwaNextApplyType firstSection.transactionPurpose.checkOptions の state key */
    TRANSACTION_PURPOSE: {
        savings: { code: "1", name: "貯蓄・資産運用" },
        living: { code: "2", name: "生活費の決済" },
        salary: { code: "3", name: "給与等の受取" },
        business: { code: "4", name: "事業費の決済" },
        foreignRemittance: { code: "5", name: "海外からの送金の受取" },
        other: { code: "6", name: "その他" },
    },
    DAIWA_NEXT_BANK_MYNUMBER_CHOICE: {
        notAssign: { code: "0", name: "マイナンバーの付番を行わない", dxoCode: "0" },
        assign: { code: "1", name: "マイナンバーの付番を行う", dxoCode: "1" },
    },
    MYNUMBER_CHOICE: {
        notAssign: { code: "0", name: "マイナンバーの付番を行わない", dxoCode: "4" },
        assignAll: { code: "1", name: "マイナンバーの付番を行う", dxoCode: "1" },
        assignByBusinessType: { code: "2", name: "業態を絞ってマイナンバーの付番を行う", dxoCode: "2" },
        assignByInstitution: { code: "3", name: "金融機関を絞ってマイナンバーの付番を行う", dxoCode: "3" },
    },
    DAIWA_NEXT_BANK_MYNUMBER_SUBMISSION: {
        directToDnb: { code: "1", name: "大和ネクスト銀行に直接マイナンバーの届出を行う", dxoCode: "1" },
        viaDepositInsurance: { code: "2", name: "預金保険機構経由でマイナンバーの届出を行う", dxoCode: "0" },
    },
    /** キーは DaiwaNextApplyType thirdSection.fuban.selectedBusiness の state key */
    CHOICE_SPECIFIC_BUSINESS_TYPE: {
        bank: { code: "1", name: "銀行" },
        yuchoBank: { code: "2", name: "ゆうちょ銀行" },
        trust: { code: "3", name: "信託銀行" },
        shinkinBank: { code: "4", name: "信用金庫" },
        laborCreditUnion: { code: "5", name: "労働金庫" },
        creditUnion: { code: "6", name: "信用組合" },
        agriculturalCooperative: { code: "7", name: "農協" },
        fisheryCooperative: { code: "8", name: "漁協" },
        businessCentral: { code: "9", name: "商工中金" },
        agriculturalCentralBank: { code: "10", name: "農林中央金庫" },
    },
    NATIONALITY_VERIFICATION_NATIONALITY: {
        japan: { code: "0", name: "日本" },
        nonJapan: { code: "1", name: "日本以外" },
    },
    GENDER: {
        male: { code: "1", name: "男性" },
        female: { code: "2", name: "女性" },
        none: { code: "3", name: "なし" },
    },
};
/** テーブル内の `code` 値でエントリを引く（セッション保存値は code のまま） */
function sessionEntryByCode(table, code) {
    return Object.values(table).find((e) => e.code === code);
}
function hasSessionCode(table, code) {
    return Object.values(table).some((e) => e.code === code);
}
/**
 * 同意フラグをセッションコードに変換
 * @param agreed 同意フラグ
 * @returns セッションコード
 */
function sessionAgreementCode(agreed) {
    return agreed
        ? exports.SESSION_CODE_TABLES.AGREEMENT.agreed.code
        : exports.SESSION_CODE_TABLES.AGREEMENT.notAgreed.code;
}
/**
 * 確認フラグをセッションコードに変換
 * @param confirmed 確認フラグ
 * @returns セッションコード
 */
function sessionConfirmedCode(confirmed) {
    return confirmed
        ? exports.SESSION_CODE_TABLES.CONFIRMED.confirmed.code
        : exports.SESSION_CODE_TABLES.CONFIRMED.notConfirmed.code;
}
/**
 * 申込あり/なしをセッションコードに変換
 * @param table テーブル
 * @param isApplied 申込あり/なし
 * @returns セッションコード
 */
function sessionApplyBinaryCode(table, isApplied) {
    return isApplied ? table.applied.code : table.notApplied.code;
}
/**
 * 画面復元など用: 空・null・undefined は未申込コードへ正規化する。
 * strict に扱う呼び出し元では `sessionApplyBinaryFromStored` を使うこと。
 * backend の registerAccount 実経路は develop 互換のマッパーフォールバックを使うため本ヘルパーは経由しない。
 */
function sessionApplyBinaryFromStoredLenient(table, stored) {
    if (stored == null || stored === "") {
        return table.notApplied.code;
    }
    if (stored === table.applied.code || stored === table.notApplied.code) {
        return stored;
    }
    throw new Error(`SESSION_VALIDATION_ERROR: 申込あり/なしのコードが不正です (${stored})`);
}
/**
 * セッションに保存された申込あり/なしをフォーム用コードへ正規化する。
 * - 空・null・undefined は SESSION_VALIDATION_ERROR（DXO 必須項目はバリデータで事前検証すること）
 * - `applied` / `notApplied` の code と一致すればそのまま
 * - それ以外（未知値）は SESSION_VALIDATION_ERROR
 */
function sessionApplyBinaryFromStored(table, stored) {
    const s = stored ?? "";
    if (s === "") {
        throw new Error("SESSION_VALIDATION_ERROR: 申込あり/なしのコードが不正です (空)");
    }
    if (s === table.applied.code || s === table.notApplied.code) {
        return s;
    }
    throw new Error(`SESSION_VALIDATION_ERROR: 申込あり/なしのコードが不正です (${stored})`);
}
/**
 * セッションに保存された申込あり/なしをDXO送信用の区分値に変換する。
 * 空・未設定は `sessionApplyBinaryFromStored` により SESSION_VALIDATION_ERROR。
 * backend の registerAccount 実経路は develop 互換のマッパーフォールバックを使うため本ヘルパーは経由しない。
 * @param table テーブル
 * @param stored セッションに保存された申込あり/なし
 * @returns DXO送信用の区分値
 */
function sessionApplyBinaryDxoFromStored(table, stored) {
    const code = sessionApplyBinaryFromStored(table, stored);
    return code === table.applied.code ? table.applied.dxoCode : table.notApplied.dxoCode;
}
